import { Component, Input } from '@angular/core';
import { ErrorMsgInfo } from '../../model/common.model';

@Component({
  selector: 'error-page',
  standalone: true,
  imports: [],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent {
@Input() errorMsg:ErrorMsgInfo = {
  status:404,
  title:'PAGE NOT FOUND',
  description:'We are sorry, but the page you requested was not found.'
};
}
